module.exports = __webpack_public_path__ + "img/8.53004718.png";